import axios from 'axios';
import toast from 'react-hot-toast';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const api = axios.create({
  baseURL: API_URL,
});

export const setupAuthToken = () => {
  const token = localStorage.getItem('userToken');
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }
};

// Interceptador de resposta para tratamento centralizado de erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error.response?.data?.error || error.message || 'Erro na requisição';
    
    // Token expirado — mas NÃO interceptar 401 nas rotas de autenticação
    const isAuthRoute = error.config?.url?.includes('/auth/login') || error.config?.url?.includes('/auth/register');
    if (error.response?.status === 401 && !isAuthRoute) {
      localStorage.removeItem('userToken');
      delete api.defaults.headers.common['Authorization'];
      window.location.href = '/login';
      toast.error('Sua sessão expirou. Por favor, faça login novamente.');
    } else if (error.response?.status === 403) {
      toast.error('Você não tem permissão para acessar este recurso.');
    } else if (error.response?.status === 404) {
      toast.error('Recurso não encontrado.');
    } else if (error.response?.status === 409) {
      toast.error(message);
    } else if (error.response?.status >= 500) {
      toast.error('Erro no servidor. Tente novamente mais tarde.');
    }
    
    return Promise.reject(error);
  }
);

export default api;